// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import React from 'react';
import { NewAccountDetailsPanelViewModel } from '../../ViewModels/NewAccountDetailsPanelViewModel';
import { ApplicationPanel } from './ApplicationPanel';
import { VerticalDetailsGroup } from '../elements/VerticalPanel/VerticalDetailsGroup';
import { HtmlScroll } from '@components/webdesktop/elements/Scroll/HtmlScroll';
import { ComboBox } from '../elements/ComboBox';
export class NewAccountDetailsPanel extends ApplicationPanel {
    constructor(props) {
        super(props, NewAccountDetailsPanelViewModel);
        this.accountDetailsContainerRef = React.createRef();
        this.panelOver = this.panelOver.bind(this);
        this.panelLeave = this.panelLeave.bind(this);
        this.onAssetChanges = this.onAssetChanges.bind(this);
    }
    componentDidMount() {
        super.componentDidMount();
        this.scrollAdd();
    }
    scrollAdd() {
        const itemContainer = this.accountDetailsContainerRef.current;
        if (!isNullOrUndefined(itemContainer)) {
            HtmlScroll.addScroll(itemContainer);
        }
    }
    panelOver(event) {
        this.viewModel.mouseOver(event);
    }
    panelLeave(event) {
        this.viewModel.mouseLeave(event);
    }
    onAssetChanges(assetMenuItem) {
        this.viewModel.selectedAsset = assetMenuItem.value;
    }
    render() {
        const { assetsVisible, assetsMenuItems, groupItems, showModalMask, left, top, visible } = this.state;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: `account-details-panel${!visible ? ' hidden' : ''}`, style: { position: 'absolute', left, top, width: '450px', height: '546px' }, onMouseEnter: this.panelOver, onMouseLeave: this.panelLeave, ref: this.props.refOnMainDiv },
                assetsVisible && (React.createElement("div", { className: "account-details-panel-assets-bar" },
                    React.createElement(ComboBox, { enabled: true, visible: assetsVisible, items: assetsMenuItems, onValueChange: this.onAssetChanges }))),
                React.createElement("div", { className: "account-details-panel-items-container", ref: this.accountDetailsContainerRef },
                    React.createElement("div", { className: "account-details-panel-groups" }, groupItems.map((groupItem, i) => (React.createElement(VerticalDetailsGroup, { key: i, groupItem: groupItem, accountDetailsItemDown: this.viewModel.accountDetailsItemDown, accountDetailsItemMove: this.viewModel.accountDetailsItemMove, accountDetailsItemUp: this.viewModel.accountDetailsItemUp })))))),
            showModalMask && React.createElement("div", { className: "js-fullscreen-dark-background" })));
    }
}
